export { ModuleTitle, type ModuleTitleProps } from './ModuleTitle';
